import React  from "react";
import loading from "../../../assets/loading.gif";
import Typography from "@mui/material/Typography";
import "../../../App.scss";
import "./template.scss";
import Box from "@mui/material/Box";

const Loading = () => {
    return (
        <div id="loadingComponent" className="loading-container">
            <Box display="flex" flexDirection="column" alignItems="center">
                <img src={loading} alt="Loading" width="140px" height="140px" />
                <Typography fontFamily="IliaOpenSansSemibold" color="#48495D" fontWeight="600" fontSize="clamp(14px,28px,32px)" textAlign="center">
                    Carregando o mapa...
                </Typography>
            </Box>
        </div>
    );
};

export default Loading;
